import type { FaireProductEntity } from "../../entity_types/product";

export const p_22q4vsqvc6: FaireProductEntity = {
  token: "p_22q4vsqvc6",
  type: "product",
  name: "Large Reusable Rolling Bag",
  brandToken: "b_umczc7bspa",
  brandName: "Queens Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/c7ffe0ddea7dab7120a1af24cad0da3ee82cb671dad264f902cf81e82775eca4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7e94359bc1727ac81693827b325d2d91f397ad64e398c4e82d848e39e9303aa6.jpeg",
    "https://cdn.faire.com/fastly/285ad6d27a4780707b8434795e3dcb0055e2dbd74be2cade9544bcd70e507d5c.jpeg",
    "https://cdn.faire.com/fastly/a9c4f76ddbd04da2be4f1b3c024dc82ccb3a2ed218757435433fba80d44b905c.jpeg",
    "https://cdn.faire.com/fastly/4425c1b153590313ccd76042b84b8b312d31d4f4908975905a9767a726113ebf.jpeg",
    "https://cdn.faire.com/fastly/93fdc193f9c480d3a0b7eeec708af62b824eba06c5c7ffeea30d0cd710bf6919.jpeg",
    "https://cdn.faire.com/fastly/d262e760bde5e3baf321e227f56121991ad29243a826120334d11cb90536fe6f.jpeg",
  ],
  priceDollars: 50,
  description:
    "- Large reusable rolling bag\n- Crafted from durable Polypropylene\n- This bag measures 16 x 24 x 20in and can hold up to 66lbs\n-  It features 4 wheels and 3 handles, making it versatile for use as a handbag, shoulder bag, \n  or shopping cart. \n- Perfect for various situations such as shopping, groceries, picnics, and travel.",
  tags: [],
  msrpDollars: 100,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:25:50.399Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
